import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
// import HomePage from '../../pages/Home';
import SearchPage from '../../pages/Search';
import ErrorPage from '../../pages/Error';
import HousingPage from '../../pages/Housing';
import HousingDetailPage from '../../pages/HousingDetail';
import VideoContentPage from '../../pages/VideoContent';
import ArticleContentPage from '../../pages/ArticleContent';
import AboutUsPage from '../../pages/AboutUs';
import JoinUsPage from '../../pages/JoinUs';
import ArticleDetail from '../../pages/ArticleDetail';

import HomePage from '../../pages/Home';
import ResultPage from '../../pages/Result';
import PrivacyPolicy from '../../pages/Privacy-Policy';
import SyaratKetentuan from '../../pages/Syarat-Ketentuan';
const AnimatedRoutesCompo = () => {
  const location = useLocation();
  return (
    <AnimatePresence>
      <Routes location={location} key={location.pathname}>
        <Route exact path="/" element={<HomePage />} />
        <Route path="/pencarian" element={<SearchPage />} />
        <Route path="/properti" element={<HousingPage />} />
        <Route path="/hasil-pencarian" element={<ResultPage />} />
        <Route path="/detail-tipe" element={<HousingDetailPage />} />
        <Route path="/konten-video" element={<VideoContentPage />} />
        <Route path="/konten-artikel" element={<ArticleContentPage />} />
        <Route path="/tentang-kami" element={<AboutUsPage />} />
        <Route path="/bergabung" element={<JoinUsPage />} />
        <Route path="/detail-artikel" element={<ArticleDetail />} />
        <Route path="/kebijakan-privasi" element={<PrivacyPolicy />} />
        <Route path="/syarat-ketentuan" element={<SyaratKetentuan />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutesCompo;
